import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const RichTextEditor = ({ content, onChange, onVoiceInput, isVoiceActive }) => {
  const [showFormatting, setShowFormatting] = useState(false);

  const toolbarButtons = [
    { icon: 'Bold', label: 'Bold', action: 'bold' },
    { icon: 'Italic', label: 'Italic', action: 'italic' },
    { icon: 'Underline', label: 'Underline', action: 'underline' },
    { icon: 'List', label: 'Bullet List', action: 'bulletList' },
    { icon: 'ListOrdered', label: 'Numbered List', action: 'numberedList' },
    { icon: 'AlignLeft', label: 'Align Left', action: 'alignLeft' },
    { icon: 'Link', label: 'Insert Link', action: 'link' }
  ];

  const handleFormat = (action) => {
    console.log(`Formatting: ${action}`);
  };

  return (
    <div className="bg-card rounded-lg border border-border overflow-hidden">
      <div className="flex items-center justify-between p-3 md:p-4 border-b border-border bg-muted/30">
        <div className="flex items-center gap-2 overflow-x-auto">
          {toolbarButtons?.map((btn, idx) => (
            <button
              key={idx}
              onClick={() => handleFormat(btn?.action)}
              className="flex items-center justify-center w-8 h-8 md:w-9 md:h-9 rounded hover:bg-muted transition-smooth flex-shrink-0"
              title={btn?.label}
            >
              <Icon name={btn?.icon} size={16} />
            </button>
          ))}
          <div className="w-px h-6 bg-border mx-1" />
          <button
            onClick={() => setShowFormatting(!showFormatting)}
            className="flex items-center justify-center w-8 h-8 md:w-9 md:h-9 rounded hover:bg-muted transition-smooth flex-shrink-0"
            title="More options"
          >
            <Icon name="MoreHorizontal" size={16} />
          </button>
        </div>

        <div className="flex items-center gap-2 flex-shrink-0 ml-2">
          <Button
            variant={isVoiceActive ? 'destructive' : 'outline'}
            size="sm"
            iconName={isVoiceActive ? 'MicOff' : 'Mic'}
            iconPosition="left"
            onClick={onVoiceInput}
          >
            <span className="hidden sm:inline">{isVoiceActive ? 'Stop' : 'Voice'}</span>
          </Button>
        </div>
      </div>
      <textarea
        value={content}
        onChange={(e) => onChange(e?.target?.value)}
        placeholder="Begin clinical documentation here... Use voice input or type your notes."
        className="w-full h-64 md:h-96 lg:h-[500px] p-4 md:p-6 bg-background text-foreground resize-none focus:outline-none text-sm md:text-base leading-relaxed"
        style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}
      />
      <div className="flex items-center justify-between p-3 md:p-4 border-t border-border bg-muted/30">
        <div className="flex items-center gap-4 text-xs md:text-sm text-muted-foreground">
          <span>{content?.length} characters</span>
          <span>{content?.split(/\s+/)?.filter(w => w?.length > 0)?.length} words</span>
        </div>
        <div className="flex items-center gap-2">
          <Icon name="Check" size={16} color="var(--color-success)" />
          <span className="text-xs md:text-sm text-success">Auto-saved</span>
        </div>
      </div>
    </div>
  );
};

export default RichTextEditor;